const REPORTER_COMMENT_LIMIT = 1000;
const ABUSE_REASONS = {
  VIOLATION_TYPE_BULLYING_AND_HARASSMENT: 'VIOLATION_TYPE_BULLYING_AND_HARASSMENT',
  VIOLATION_TYPE_CHEATING_AND_EXPLOITS: 'VIOLATION_TYPE_CHEATING_AND_EXPLOITS',
  VIOLATION_TYPE_DATING_AND_ROMANTIC: 'VIOLATION_TYPE_DATING_AND_ROMANTIC',
  VIOLATION_TYPE_DIRECTING_USERS_OFF_PLATFORM: 'VIOLATION_TYPE_DIRECTING_USERS_OFF_PLATFORM',
  VIOLATION_TYPE_OTHER: 'VIOLATION_TYPE_OTHER',
  VIOLATION_TYPE_ASKING_FOR_PII: 'VIOLATION_TYPE_ASKING_FOR_PII',
  VIOLATION_TYPE_SCAMS: 'VIOLATION_TYPE_SCAMS',
  VIOLATION_TYPE_PROFANITY: 'VIOLATION_TYPE_PROFANITY'
};

export { REPORTER_COMMENT_LIMIT, ABUSE_REASONS };
